import { COLOR_PALETTE, COMPANY_COLORS } from '@/constants/colors.constant'
import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { FactorRiskColors } from '@/interfaces/factorLens.interface'

// cwan-ux: factor bars use the cwan brand sequential palette
export const BAR_COLORS: string[] = [...COLOR_PALETTE]

/** Factor Lens chart/grid colors derived from the dashboard theme. */
export function useFactorRiskColors(): FactorRiskColors {
  const theme = useTheme()
  return {
    totalColor: theme.factorLensTotalColor,
    totalBorder: theme.factorLensTotalBorder,
    totalSelected: theme.factorLensTotalSelected,
    specificColor: theme.factorLensSpecificColor,
    specificBorder: theme.factorLensSpecificBorder,
    specificSelected: theme.factorLensSpecificSelected,
    barColors: BAR_COLORS,
    negativeBarColor: COMPANY_COLORS.ERROR,
  }
}
